/**
 * Line Tool Settings Panel
 * Settings for stroke color and width
 */

import React from 'react';
import { useToolbarStore } from '@/stores/toolbarStore';
import { ColorSwatch } from '@/components/ui/BrushPicker';

export function LineToolSettings() {
  const { lineDefaults, updateLineDefaults } = useToolbarStore();

  return (
    <div className="space-y-3">
      {/* Stroke color */}
      <div className="min-w-0">
        <label className="block text-[10px] uppercase tracking-wider text-fg-subtle mb-1">
          Stroke Color
        </label>
        <ColorSwatch
          value={lineDefaults.stroke}
          onChange={(stroke) => updateLineDefaults({ stroke })}
        />
      </div>

      {/* Stroke width */}
      <div>
        <label className="block text-[10px] uppercase tracking-wider text-fg-subtle mb-1">
          Stroke Width
        </label>
        <input
          type="number"
          value={lineDefaults.strokeWidth}
          onChange={(e) => updateLineDefaults({ strokeWidth: parseInt(e.target.value) || 1 })}
          min={1}
          max={50}
          className="w-full bg-navy border border-white/10 rounded-lg px-2 py-1.5 text-sm text-fg focus:outline-none focus:border-primary/50"
        />
      </div>
    </div>
  );
}
